import penetasanDevin3 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Devin Edsel_3 Large.jpeg";
import penetasanRavalen4 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Ravalen Virginia_4 Large.jpeg";
import penetasanThirza6 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Thirza_6 Large.jpeg";
import penetasanJohan3 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Johan Felix_3 Large.jpeg";
import penetasanKenzie1 from "../../Assets/Penetasan-Revisi/Hari-Penetasan_Kenzie-Andhika-Theodorus-Suhanto_1-Large.jpeg";
import penetasanThirza3 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Thirza_3 Large.jpeg";
import penetasanAzkia4 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Azkia Noor Aina_04 Large.jpeg";
import penetasanJohan4 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Johan Felix_4 Large.jpeg";
import penetasanBernice2 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Bernice_02 Large.jpeg";
import penetasanKenzie4 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Kenzie Andhika Theodorus Suhanto_4 Large.jpeg";
import penetasanKelvin3 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Kelvin Kurniawan_03 Large.jpeg";
import penetasanDevin7 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Devin Edsel_7 Large.jpeg";
import penetasanKelvin9 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Kelvin Kurniawan_09 Large.jpeg";
import penetasanAndrew1 from "../../Assets/Penetasan-Revisi/Hari_Penetasan_Andrew Su_1 Large.jpeg";
import penetasanStevan5 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Stevan Antonius-5 Large.jpeg";
import penetasanRavalen5 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Ravalen Virginia_5 Large.jpeg";
import penetasanRavalen2 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Ravalen Virginia_2 Large.jpeg";
import penetasanKelvin12 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Kelvin Kurniawan_12 Large.jpeg";
import penetasanCinta8 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Cinta_8 Large.jpeg";
import penetasanAzkia3 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Azkia Noor Aina_03 Large.jpeg";
import penetasanBernice4 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Bernice_04 Large.jpeg";
import penetasanStevan3 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Stevan Antonius-3 Large.jpeg";
import penetasanCinta9 from "../../Assets/Penetasan-Revisi/Hari Penetasan_Cinta_9 Large.jpeg";
import penetasanAndrew5 from "../../Assets/Penetasan-Revisi/Hari_Penetasan_Andrew Su_5 Large.jpeg";

const hariPenetasan = [
  { id: 1, img: penetasanDevin3 },
  { id: 2, img: penetasanRavalen4 },
  { id: 3, img: penetasanThirza6 },
  { id: 4, img: penetasanJohan3 },
  { id: 5, img: penetasanKenzie1 },
  { id: 6, img: penetasanThirza3 },
  { id: 7, img: penetasanAzkia4 },
  { id: 8, img: penetasanJohan4 },
  { id: 9, img: penetasanBernice2 },
  { id: 10, img: penetasanKenzie4 },
  { id: 11, img: penetasanKelvin3 },
  { id: 12, img: penetasanDevin7 },
  { id: 13, img: penetasanKelvin9 },
  { id: 14, img: penetasanAndrew1 },
  { id: 15, img: penetasanStevan5 },
  { id: 16, img: penetasanRavalen5 },
  { id: 17, img: penetasanRavalen2 },
  { id: 18, img: penetasanKelvin12 },
  { id: 19, img: penetasanCinta8 },
  { id: 20, img: penetasanAzkia3 },
  { id: 21, img: penetasanBernice4 },
  { id: 22, img: penetasanStevan3 },
  { id: 23, img: penetasanCinta9 },
  { id: 24, img: penetasanAndrew5 }
];

export default hariPenetasan;